import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { getOnePaymentMoneyPools } from 'services/easyPay'

export default function useGetMoneypoolPayment() {
    const { id } = useParams()
    const { data, isLoading } = useQuery(
        ['group-payment-all-for-moneypool', id],
        getOnePaymentMoneyPools
    )
    return { moenyPool: data, isLoadingMoneypool: isLoading }
}
